import { render } from "./AuthorConfirm.vue?vue&type=template&id=1ca0215e&scoped=true&ts=true"
import script from "./AuthorConfirm.vue?vue&type=script&lang=ts"
export * from "./AuthorConfirm.vue?vue&type=script&lang=ts"

import "./AuthorConfirm.vue?vue&type=style&index=0&id=1ca0215e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca0215e"]])

export default __exports__